import { render, staticRenderFns } from "./contentModal.vue?vue&type=template&id=200584b6&scoped=true&"
import script from "./contentModal.vue?vue&type=script&lang=js&"
export * from "./contentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200584b6",
  null
  
)

export default component.exports